module.exports = __webpack_public_path__ + "img/feature-index_3.79eaf489.png";